/* eslint-disable no-barrel-files/no-barrel-files */
import {
  SEARCH_PARAM_CDF,
  SEARCH_PARAM_INSPECTION_ID,
} from 'routes/(common_search_params)/-searchParams'

export { SEARCH_PARAM_CDF, SEARCH_PARAM_INSPECTION_ID }

export const SEARCH_PARAM_VISUAL_INSPECTION_ID = 'visualInspectionId'
export const SEARCH_PARAM_SHOW_3D = 'show3D'
export const SEARCH_PARAM_MIN_FILTER = 'minFilter'
export const SEARCH_PARAM_MAX_FILTER = 'maxFilter'
export const SEARCH_PARAM_MARKUP_LAYERS = 'markupLayers'
export const SEARCH_PARAM_EXTENSION = 'extension'
export const SEARCH_PARAM_HEATMAP_DISPLAY_STATE = 'heatmapDisplayState'
export const SEARCH_PARAM_MARKUP_LAYER_LABEL_VISIBILITY =
  'markupLayerLabelVisibility'
export const SEARCH_PARAM_INDICATION = 'indication'
export const SEARCH_PARAM_POINT_CLOUD_ID = 'pc'
export const SEARCH_PARAM_FORGING_VIEW_TYPE = 'view'
